let nextTask = 0

export const addTask  = (title, status, startDate, endDate) => ({
    type: 'ADD_TASK',
    id: nextTask++,
    title,
    status,
    startDate,
    endDate
})

export const changeTaskDates = (taskId, actionType, startDate, endDate) => ({
    type: 'CHANGE_TASK_DATES',
    taskId,
    startDate,
    endDate,
    actionType
})

export const setCurrentTask = (id) => ({
    type: 'SET_CURRENT_TASK',
    id
})

export const setCurrentTaskDates = (actionType, startDate, endDate) => ({
    type: 'SET_CURRENT_TASK_DATES',
    startDate,
    endDate,
    actionType
})

export const resetCurrentTask = () => ({
    type: 'RESET_CURRENT_TASK'
})

export const toggleCalendar = (id) => ({
    type: 'TOGGLE_CALENDAR',
    id
})

export const setTooltipType = (text) => ({
    type: 'SET_TOOLTIP_TYPE',
    text
})
